// extracted by mini-css-extract-plugin
module.exports = {"shade":"_53b86379","shadeContainer":"e47854a7","shadeDetail":"_6e1e0509","shadeHandle":"_2dd7f49e","shadeLogo":"_97329910","shadeHandleFocusBox":"c56caf02","isDown":"c1229923"};